import React from "react";

function Projects() {
  return <div></div>;
}

export default Projects;
